import script from "./Page__Testimonials.vue?vue&type=script&setup=true&lang=js"
export * from "./Page__Testimonials.vue?vue&type=script&setup=true&lang=js"

import "./Page__Testimonials.vue?vue&type=style&index=0&id=41503a6c&lang=scss"

const __exports__ = script;

export default __exports__